module.exports = __webpack_public_path__ + "img/discord-circle.f8e91b93.svg";